import React from 'react';
import { TextBold } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const BoldButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().toggleBold().run();
  const onClick = () => editor.chain().focus().toggleBold().run();
  const variant = editor.isActive('bold') ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='bold'>
      <TextBold />
    </MenuButton>
  );
};
